import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=82afa7e8&"
import script from "./repair.vue?vue&type=script&lang=js&"
export * from "./repair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports